import React from "react";
import LabelWidget from "./LabelWidget";
import { DropLi } from "hooks";

const LabelPrintLayout = ({ data }) => {
  const { PrintType } = DropLi();
  const layout = PrintType.find((j) => j.id === data.printType);

  const { columns, rows } = layout;
  const itemsPerPage = columns * rows;

  // Flatten items based on quantity (nol)
  const flattenedItems = data.items.flatMap((item) => {
    const copies = item.nol || 1;
    return Array.from({ length: copies }, (_, idx) => ({
      ...item,
      _key: `${item.key}-${idx}`,
    }));
  });

  // Pad to make sure all pages are filled
  while (flattenedItems.length % itemsPerPage !== 0) {
    flattenedItems.push(null);
  }

  // Chunk items into pages
  const pages = [];
  for (let i = 0; i < flattenedItems.length; i += itemsPerPage) {
    pages.push(flattenedItems.slice(i, i + itemsPerPage));
  }

  return (
    <div>
      {pages.map((pageItems, pageIndex) => (
        <div
          key={`page-${pageIndex}`}
          style={{
            pageBreakAfter: "always",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(${columns}, 1fr)`,
              gap: "5px",
              fontFamily: "monospace",
            }}
          >
            {pageItems.map((item, i) =>
              item ? (
                <LabelWidget key={item._key} value={data} item={item} />
              ) : (
                <div key={`empty-${i}`} />
              )
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default LabelPrintLayout;
